import 'firebase/auth';
import { YoAuthUser } from '@yakoffice/yakoffice-firebase';

export interface IToolUserClaims {
  MiniclipPublicAccess: boolean;
  DevelopmentClaims: boolean;
  ProductionClaims: boolean;
  QasClaims: boolean;
  BuildsAdmin: boolean;
}

export class ToolUserClaims implements IToolUserClaims {

  readonly MiniclipPublicAccess: boolean;
  readonly DevelopmentClaims: boolean;
  readonly ProductionClaims: boolean;
  readonly QasClaims: boolean;
  readonly BuildsAdmin: boolean;

  constructor(authUser: YoAuthUser | undefined, projectId: string, miniclipPublicAccess: boolean) {
    this.MiniclipPublicAccess = miniclipPublicAccess;
    this.DevelopmentClaims = authUser ? !!authUser.getGameEnvironmentRoles(projectId, 'development') : false;
    this.ProductionClaims = authUser ? !!authUser.getGameEnvironmentRoles(projectId, 'production') : false;
    this.QasClaims = authUser ? !!authUser.getGameEnvironmentRoles(projectId, 'qas') : false;
    this.BuildsAdmin = authUser ? !!authUser.getProjectRoles(projectId, 'BuildsAdmin') : false;
  }
}

